module.exports = __webpack_public_path__ + "img/elo.f4107014.svg";